import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';
import { THotelOccupancy } from 'types/hotelOccupancy';

export const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString(window.navigator.language.toLocaleLowerCase());
};

export const getChartWidth = (): number => {
    const width = document.querySelector('.u-container')?.clientWidth;
    return width && width > 0 ? width * 0.75 : 1000;
};

export const buildOptions = (data: THotelOccupancy | null = null): any => {
    return {
        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        legend: {
            enabled: false
        },
        colors: ['#A090CC'],
        yAxis: {
            min: 0,
            max: data?.hotelRoomsCount ?? 0,
            title: {
                text: ''
            }
        },
        xAxis: {
            categories: data?.planningListByDate?.map((occupancy) => formatDate(occupancy.date)),
            plotBands: [{ color: '#F5F3FB' }]
        },
        plotOptions: {},
        series: [{ data: data?.planningListByDate?.map((occupancy) => occupancy.occupiedRooms) }],
        accessibility: {
            enabled: false
        },
        responsive: {
            rules: [
                {
                    condition: {
                        callback: () => true
                    },
                    chartOptions: {
                        chart: {
                            width: getChartWidth()
                        }
                    }
                }
            ]
        }
    };
};

export const OccupationChart = ({ data }: { data?: THotelOccupancy | null }): JSX.Element => {
    return (
        <div className="chart">
            <HighchartsReact highcharts={Highcharts} options={buildOptions(data)} />
        </div>
    );
};
